import { useState } from 'react'
import { Stack } from '@chakra-ui/react'

import { CustomFormValidateField } from 'components/tools/CustomForm/types'
import { FormItem, MaskedInput } from 'components'
import { hourMask } from 'utils/masks'
import { validateHour } from 'utils/validation/validators'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'
import useSetDefaultValueOnNotArrayData from '../../hooks/useSetDefaultValueOnNotArrayData'

export default function DefaultValueHour({ formMethods, question }: DefaultValueCommonProps) {
  const [isFieldValid, setIsFieldValid] = useState<CustomFormValidateField>({
    isValid: true,
    message: '',
  })

  const handleValidateHour = (hour: string): boolean => {
    let initialValue = { isValid: true, message: '' }

    if (hour && !validateHour(hour)) {
      initialValue = { isValid: false, message: 'Horário está errado' }
    }

    setIsFieldValid(initialValue)
    return initialValue.isValid
  }

  useUnregisterDefaultValueField({ formMethods })

  useSetDefaultValueOnNotArrayData({ formMethods, question })

  return (
    <Stack>
      <FormItem label="Valor inicial">
        <MaskedInput
          mask={hourMask}
          {...formMethods.register('default_value', {
            validate: handleValidateHour,
          })}
        />
      </FormItem>

      <CustomFormFieldErrorMessage {...isFieldValid} />
    </Stack>
  )
}
